import { Injectable } from '@angular/core';
import {
  LBSErrorHandler,
  LBSErrorHandlerResult,
} from 'src/app/_services/error-handler/error-handler';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { FormFieldError } from './form-field-errors';

@Injectable({
  providedIn: 'root',
})
export class FormFieldErrorHandler implements LBSErrorHandler {
  // Lifecycle
  constructor(private logger: LoggingService) {}

  public async handleError(error: Error): Promise<LBSErrorHandlerResult> {
    if (
      Object.values(FormFieldError).includes(error?.message as FormFieldError)
    ) {
      return await this.getErrorHandlerResultForKey(
        error.message as FormFieldError,
      );
    }
    this.logger.log(
      this.constructor.name,
      'given error',
      error?.message,
      'is not of type FormFieldError',
    );
    return undefined;
  }

  // Private Functions
  public async getErrorHandlerResultForKey(
    error: FormFieldError,
  ): Promise<LBSErrorHandlerResult> {
    switch (error) {
      case FormFieldError.INACTIVE_MATERIAL_FOUND:
        return {
          alert: {
            title:
              'ERROR-HANDLERS.FORMFIELD-ERRORS.INACTIVE_MATERIAL_FOUND.TITLE',
            subtitle:
              'ERROR-HANDLERS.FORMFIELD-ERRORS.INACTIVE_MATERIAL_FOUND.SUBTITLE',
            message:
              'ERROR-HANDLERS.FORMFIELD-ERRORS.INACTIVE_MATERIAL_FOUND.MESSAGE',
            confirm:
              'ERROR-HANDLERS.FORMFIELD-ERRORS.INACTIVE_MATERIAL_FOUND.CONFIRM',
            confirmFunc: () => {
              console.log(
                'Inactive material ok pressed -> Jump out of Form???',
              );
            },
            showExportLog: false,
          },
        };

      default:
        this.logger.error(
          this.constructor.name,
          'Not Handled FormFieldError found!',
          error,
        );
        return undefined;
    }
  }
}
